@for (row of rows; track row) {
  <svg:svg class="calendar" [attr.x]="0" [attr.y]="cfg.cellHeight * row"
    [attr.width]="cfg.calendarSize.width" [attr.height]="cfg.cellHeight">
    @for (col of cols; track col) {
      <svg:svg class="day" [attr.x]="cfg.cellWidth * col" y="0" [attr.width]="cfg.cellWidth"
             [attr.height]="cfg.cellHeight" (click)="onSelectDate(days[row][col])" [ngClass]="{
                    currentMonth: days[row][col].isInCurrentMonth,
                    unclickable: ! days[row][col].isInCurrentMonth,
                    uncheckable: !days[row][col].isCheckable,
                    isInRange: days[row][col].isInRange,
                    today: days[row][col].isToday,
                    boundary: days[row][col].isBoundary
                }">
        <svg:rect y="0" x="0" [attr.width]="cfg.cellWidth" [attr.height]="cfg.cellHeight" [ngStyle]="{
                        fill: days[row][col].isWeekend
                            ? (days[row][col].isCheckable ? 'url(#dotted-pattern)' : 'url(#red-dotted-pattern)')
                            : ''
                    }">
          </svg:rect>
          @if (days[row][col].isToday || days[row][col].isBoundary) {
            <svg:circle r="10" cx="12" cy="12">
              </svg:circle>
            }
            <svg:text x="50%" y="50%" dominant-baseline="central" text-anchor="middle">
              {{ days[row][col].day }}
              </svg:text>
              </svg:svg>
            }
            </svg:svg>
          }
          <svg:line class="border" [attr.x1]="0" [attr.y1]="0" [attr.x2]="cfg.calendarSize.width" [attr.y2]="0"></svg:line>
            <svg:line class="border" [attr.x1]="cfg.calendarSize.width" [attr.y1]="0" [attr.x2]="cfg.calendarSize.width" [attr.y2]="cfg.calendarSize.height"></svg:line>
              <svg:line class="border" [attr.x1]="cfg.calendarSize.width" [attr.y1]="cfg.calendarSize.height" [attr.x2]="0" [attr.y2]="cfg.calendarSize.height"></svg:line>
                <svg:line class="border" [attr.x1]="0" [attr.y1]="cfg.calendarSize.height" [attr.x2]="0" [attr.y2]="0"></svg:line>
